import React, { useContext } from "react";
import { InterviewContext } from "../../../context/InterviewProvider";

const RecordingTime = ({ title = "Recording" }) => {
  const interviewContext = useContext(InterviewContext);

  return (
    <>
      <span className="fs-5 mb-2">{title}</span>
      <span
        className="d-flex align-items-center gap-2"
        style={{
          marginTop: "-7px",
        }}
      >
        <i
          className="ri-record-circle-line"
          style={{
            fontSize: "30px",
            color: "red",
          }}
        ></i>
        <span
          className="fw-semibold fs-3"
          style={{
            color: "#0A65CC",
          }}
        >
          {interviewContext?.elapsedTime}
        </span>
        <span
          className="fs-5"
          style={{
            marginTop: "4px",
          }}
        >
          min
        </span>
      </span>
    </>
  );
};

export default RecordingTime;
